import React, { useState, useContext } from 'react';
import { SET_SELECTED_PROJECT_ID, TOGGLE_SHOW_ACCEPT_INVITATION_DIALOG, UPDATE_INVITATION } from '../InvitationEvents';
import { useInvitation } from '../../../../Context/Invitation/InvitationContext';
import { updateTenantProject } from '../../../../API/Tenant/Tenant';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import PublishingAppForTenant from '../../../Dashboard/SolutionLibrary/PublishingAppForTenant';
import { GlobalContext } from '../../../../Renderers/GlobalContext';
import { useTranslation } from 'react-i18next';

const AcceptInvitationDialog = () => {
    const [inProgress, setInProgress] = useState(false);
    const { state, dispatch } = useInvitation();
    const { user, organization } = useContext(GlobalContext).state;
    const invitation = state.invitations
    const selectedProject = invitation.masterProjects.find(project => project.masterProjectId === state.selectedProjectId);
    const invitedByUser = state.invitations.invitedByUser || {};

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })

    const handleAcceptInvitation = () => {
        setInProgress(true);
    }
    const handleCreateApp = async (updatedData) => {
        try {
            const tenantCreatedDate = new Date();
            const properties = {
                status: "accepted",
                tenantProjectId: updatedData._id,
                tenantProjectCreatedDate: tenantCreatedDate
            }
            const response = await updateTenantProject(invitation._id, selectedProject.masterProjectId, properties);
            if (!response) {
                throw new Error("Failed to update invitation data");
            }
            dispatch({
                type: UPDATE_INVITATION,
                payload: {
                    id: selectedProject.masterProjectId,
                    data: {
                        ...properties,
                        tenantProject: updatedData
                    }
                }
            })
        } catch (error) {
            console.error("Error accepting invitation:", error);
        } finally {
            setInProgress(false);
            handleClose();
        }
    }

    const handleClose = () => {
        dispatch({ type: SET_SELECTED_PROJECT_ID, payload: null });
        dispatch({ type: TOGGLE_SHOW_ACCEPT_INVITATION_DIALOG });
    }

    const handleCloneFailed = async () => {
        try {
            const properties = {
                status: "clone_failed",
                tenantProjectId: "",
                tenantProjectCreatedDate: null
            }
            const response = await updateTenantProject(invitation._id, selectedProject.masterProjectId, properties);

            if (!response) {
                throw new Error("Failed to update invitation data");
            }
            dispatch({
                type: UPDATE_INVITATION,
                payload: {
                    id: selectedProject.masterProjectId,
                    data: properties
                }
            });
        } catch (error) {
            console.error("Error accepting invitation:", error);
        } finally {
            setInProgress(false);
            handleClose();
        }
    }

    if (!invitation) return null;

    let title = inProgress ?
        t("creating_app")
        :
        t("accept_invitation");

    if (inProgress) {
        title = selectedProject ? title + " - " + selectedProject.masterProject.name : title;
    }

    return (
        <Dialog
            title={title}
            onClose={handleClose}
            width={700}
            height={350}
        >
            <div className='d-flex flex-column justify-content-center h-100 w-100 py-4'>
                {inProgress ? (
                    <PublishingAppForTenant
                        user={user}
                        organization={organization}
                        selectedApp={selectedProject.masterProject}
                        instanceId={selectedProject.masterAppId}
                        onCancel={handleClose}
                        onCreate={handleCreateApp}
                        onCloneFailed={handleCloneFailed}
                    />
                ) : (
                    <div className="d-flex my-3 align-items-center dialog-content">
                        <i className="fas fa-envelope-open-text text-danger display-6 mx-4"></i>
                        <div>
                            <div className='mb-3 display-7'>
                                {t("accept_message")}
                            </div>
                            <div className='mb-3'>
                                {invitedByUser.firstName} {invitedByUser.lastName}
                                &nbsp;
                                {t("accept_message2")}
                                <span className="text-primary mx-1">
                                    {selectedProject.masterProject.name}
                                </span>
                                {t("accept_message3")}
                                <span className="text-primary ms-1">
                                    {organization.orgName}
                                </span>
                                .
                            </div>
                            <div className='mb-3'>
                                {t("accept_message4")}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {
                !inProgress && (
                    <DialogActionsBar layout='end'>
                        <div className='mb-3 me-3'>
                            <button className="btn btn-secondary" onClick={handleClose}>
                                {t("cancel_button")}
                            </button>
                            <button className="btn btn-primary" onClick={handleAcceptInvitation} disabled={inProgress}>
                                {t("accept_button")}
                            </button>
                        </div>
                    </DialogActionsBar>
                )
            }
        </Dialog >
    )
}

export default AcceptInvitationDialog;